import { MailOutlined } from '@ant-design/icons';
import { Button, Flex, Form, Input, theme } from 'antd';
import { type ReactNode, useContext, useState } from 'react';
import { catchError, EMPTY, finalize, tap } from 'rxjs';
import { AuthContext } from '../../contexts/auth-context-provider';

const requiredEmailMessage = 'Please enter your email!';
const validEmailMessage = 'Email is not valid!';

const LoginForm = (props: { onSuccess: (email: string) => void }): ReactNode => {
  const { onSuccess } = props;
  const { login } = useContext(AuthContext);
  const { token } = theme.useToken();
  const [formInstance] = Form.useForm();
  const [isSubmitting, setSubmitting] = useState(false);

  const submitSignIn = (values: any): void => {
    const { email } = values;
    setSubmitting(true);
    login(email)
      .pipe(
        finalize(() => {
          setSubmitting(false);
        }),
        tap(() => {
          onSuccess(email);
        }),
        catchError((error) => {
          formInstance.setFields([
            {
              name: 'email',
              errors: [error.message],
            },
          ]);
          return EMPTY;
        })
      )
      .subscribe();
  };

  return (
    <Form layout="vertical" form={formInstance} style={{ width: '320px' }} onFinish={submitSignIn}>
      <Flex gap="middle" vertical>
        <Form.Item
          name="email"
          rules={[
            { required: true, message: requiredEmailMessage },
            {
              type: 'email',
              message: validEmailMessage,
            },
          ]}
          hasFeedback
          validateFirst={true}
        >
          <Input
            prefix={<MailOutlined className="site-form-item-icon" />}
            placeholder="username@example.com"
            size="large"
            styles={{
              prefix: { marginInlineEnd: token.marginSM, marginInlineStart: 0 },
            }}
            type="email"
            ref={(ref) => ref?.input?.setAttribute('autocomplete', 'username')}
          />
        </Form.Item>

        <Form.Item>
          <Button block type="primary" htmlType="submit" disabled={isSubmitting} size="large">
            {isSubmitting ? 'Signing in..' : 'Sign in'}
          </Button>
        </Form.Item>
      </Flex>
    </Form>
  );
};

export default LoginForm;
